import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-background-50">
                <span className="text-accent-500">韩</span>国漫画网
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              韩国漫画网是最全的韩漫网站，为您提供免费漫画在线观看服务。资源覆盖广泛、更新及时、界面简洁，是您阅读韩国漫画的首选平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}韩漫
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/romance" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap">热门韩漫</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap">最新更新</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li><i className="ri-mail-line mr-2"></i>contact@koreamanhua.com</li>
              <li><i className="ri-map-pin-line mr-2"></i>韩国首尔特别市</li>
              <li><i className="ri-time-line mr-2"></i>每日 09:00 - 22:00</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩国漫画网 - 最全的韩漫网站. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-foreground-300 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-foreground-300 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="hover:text-foreground-300 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}